import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-reviewers',
  templateUrl: './reviewers.component.html',
  styleUrls: ['./reviewers.component.scss']
})
export class ReviewersComponent implements OnInit {

  mounted: boolean = false;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 600,
    autoplay: false,
    margin: 15,
    navText: ['&#8249', '&#8250;'],
    items: 4,
    responsive: {
      0: {
        items: 1
      },
      690: {
        items: 2
      },
      930: {
        items: 4
      }
    },
    nav: false
  }

  reviews: any[] = [
    {
      "color": "green",
      "author": "Simone Lima",
      "description": "Encantada, médica de imenso coração. Super atenciosa, tirou minhas dúvidas de formas muito esclarecedora. Minha filha ainda criança, e fomos muito bem recebidas e atendidas. Super recomendo !!"
    },
    {
      "color": "blue",
      "author": "JG Falcade",
      "description": "Nunca fui atendido por uma profissional tão atenciosa. Me explicou o que eu tinha, justificou suas opções de medicamentos, me acalmou, acolheu e tranquilizou. Não a conhecia, mas que sorte foi ter sido atendido por ela. Que toda pessoa necessitada possa passar por seus cuidados."
    },
    {
      "color": "pink",
      "author": "Elisaine Martins",
      "description": "Realmente a Medicina é doação. E a Dra.Vanessa retrata perfeitamente. Que Deus continue te abençoando e continue sendo está profissional brilhante e ética"
    },
    {
      "color": "red",
      "author": "Mariangela Sansalone",
      "description": "Perfeito! Excelente profissional. Sucesso Dra. Vanessa.  Precisando de Pneumologista? Super recomendo. Parabéns! "
    },
    {
      "color": "blue",
      "author": "Kathia Brienza",
      "description": "Excelente profissional! Faz um ótimo exame, dá várias explicações. Gostei muito, sempre que necessário voltarei nesta médica."
    },
    {
      "color": "pink",
      "author": "Inês Arruda",
      "description": "Ótimo atendimento! A doutora é muito atenciosa. Tive sequelas do Covid-19 e já estou bem melhor depois do atendimento com ela. Super recomendo."
    },
    {
      "color": "gray",
      "author": "Bruno Bisoni",
      "description": "Dra Vanessa Lago excelente profissional, me atendeu com prontidão, atenciosa, capacitada e muito competente."
    },
    // {
    //   "author": "Marina Acosta Cleto",
    //   "description": "Conheci a Dra Vanessa num momento bem delicado para a minha família, confesso que me surpreendi com o atendimento que tivemos, ela é  extremamente  humana, dedicada e excelente profissional, sempre preocupada e prestativa com os pacientes e familiares. Recomendo com toda a certeza, todo paciente merece ser tratado por ela, enfrentar as dificuldades que as doenças trazem não são fáceis, mas quando somos acolhidos, temos explicações claras e uma escuta humanizada, a batalha se torna mais possível de vencer vencida."
    // },
    {
      "color": "green",
      "author": "Viviane Negocios Imobiliarios",
      "description": "Excelente médica,, atenciosa, adorei,,recomendo demais."
    },
    {
      "color": "pink",
      "author": "Magda Vitoratte",
      "description": "Profissional excepcional e de extrema competência. Atendimento humanizado e gentil. Recomendo!!!"
    },
    {
      "color": "red",
      "author": "Lucas Corrêa",
      "description": "Profissional excelente! Muito dedicada e atenciosa para com seus pacientes."
    },
    {
      "color": "blue",
      "author": "Ana Beatriz Fonseca",
      "description": "Recomendo muito, pois a doutora Vanessa tem um excelente atendimento. Solucionou da melhor forma o meu problema."
    },
    {
      "color": "green",
      "author": "Marcos Fagundes",
      "description": "Muito atenciosa e educada. Ótima médica, atendimento. Lugar muito agradável. Recomendo."
    },
    {
      "color": "gray",
      "author": "Danilo Simões",
      "description": "Extremamente atenciosa, elucidativa e educada."
    },
    {
      "color": "red",
      "author": "Maysa Stievano",
      "description": "Excelente profissional  além do carisma e atenção para com seus pacientes"
    },

  ];

  constructor() { }

  ngOnInit(): void {
    this.mounted = true;
  }

  setPictureColor() {
    if (!this.mounted) {
      let colors = ['blue', 'gray', 'pink', 'green'];
      let selectedColor = colors[Math.floor(Math.random() * 5)];

      return selectedColor;
    }
  }

}
